export const GRAPH_API = {
  me: 'https://graph.microsoft.com/v1.0/me',
  photo: 'https://graph.microsoft.com/v1.0/me/photo/$value',
} as const;
